import { LinkReturnToMain } from 'Components';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';

export const LinkReturnToLobby = () => {
  const { setStepIndex } = useContext(SuppliersContext);

  //TODO Move to context after it exists
  const resetSupplierPageHandler = () => {
    setStepIndex(0);
  };

  return (
    <LinkReturnToMain
      label={Dictionary[DICTIONARY.General].back}
      onClick={resetSupplierPageHandler}
    />
  );
};
